import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import WorkspaceEditForm from "@/components/admin/workspace/WorkspaceEditForm";
import { routes } from "@/configs/router.config/routes";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { WorkspaceService } from "@/services/workspace/workspace.service";
import { showError, showSuccess } from "@/utils/notification";

const WorkspaceEditPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { workspaces, mutate } = useWorkspaces();

  const { id } = useParams();
  if (!id) return <></>;

  const workspace = workspaces?.find((workspace) => workspace.id === id);

  const submit = async (name: string) => {
    try {
      setIsLoading(true);
      await WorkspaceService.updateWorkspace(id, name);
      await mutate();
      setIsLoading(false);
      showSuccess("ワークスペースを更新しました。");
      navigate(routes.workspaceList);
    } catch (error) {
      console.error(error);
      showError("ワークスペースの更新に失敗しました。");
    }
  };

  return (
    <>
      <PageHeader hasBack title="ワークスペース更新" />

      <WorkspaceEditForm submit={submit} isLoading={isLoading} isUpdate={true} workspace={workspace} />
    </>
  );
};

export default WorkspaceEditPage;
